import { Box, Flex, styled } from '@withjoy/joykit';
import { breakpointAliasPx, pxToRem } from '@withjoy/joykit/theme';
import { NavLink } from '@react-router';

export const StyledNavLink = styled(Box).attrs({ as: NavLink })`
  white-space: no-wrap;
  display: inline-block;
  :hover {
    color: ${props => props.theme.colors.linkHover};
  }
  :active {
    color: ${props => props.theme.colors.linkActive};
  }
`;

export const StyledDepartmentsContainer = styled(Flex)`
  width: 100%;
  max-width: ${pxToRem(breakpointAliasPx.md3)};
  height: ${pxToRem(700)};
  flex-direction: column;
  flex-wrap: wrap;
  column-gap: ${pxToRem(48)};
  row-gap: ${pxToRem(42)};
  list-style: none;
`;
